<template>
  <div
    class="enext-input enext-input--checkbox"
    :class="[
      rules && rules.length ? 'enext-input--validable' : '',
      errorMessage ? 'invalid' : '',
      $attrs?.class ? $attrs.class : '',
      useMarkdown ? 'uses-markdown' : ''
    ]"
  >
    <k-checkbox
      class="checkbox-wrapper"
      v-bind="{
        name: uuid + '_inputtext',
        id: uuid + '_inputtext',
        ...customAttrs,
      }"
      ref="k-check"
    >
      <slot />
      <k-label
        v-if="label"
        class="k-checkbox-label"
        :for="uuid + '_inputtext'"
      >
        <span
          v-if="!useMarkdown"
          v-html="label"
          :for="uuid + '_inputtext'"
        />
        <Markdown
          v-else
          class="markdown-label"
          :text="label"
        />
      </k-label>
    </k-checkbox>
    <ErrorMessage
      :error-message="errorMessage"
      class="enext-input__errormessage enext-input--checkbox__errormessage"
    />
  </div>
</template>

<script>
import {Checkbox} from '@progress/kendo-vue-inputs'
import {Label} from '@progress/kendo-vue-labels'
import useInputValidation from '~/composables/useInputValidation'
import ErrorMessage from '~/components/input-components/ErrorMessage'
import Markdown from '~/components/Markdown.vue'

export default {
  inheritAttrs: false,
  components: {
    ErrorMessage,
    Markdown,
    'k-checkbox': Checkbox,
    'k-label': Label
  },
  props: {
    rules: {
      type: Array,
      required: false,
      default() {
        return []
      }
    },
    label: {
      type: String,
      default() {
        return ''
      }
    },
    useMarkdown: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  setup(props, {attrs}) {
    const {errorMessage, fallbackValue, validate, getName} = useInputValidation({
      rules: computed(() => props.rules),
      getAttrs: () => attrs
    })

    return {
      errorMessage,
      fallbackValue,
      validate,
      getName
    }
  },
  methods: {
    getValue() {
      return this.$refs['k-check'].checked
    }
  },
  computed: {
    customAttrs() {
      let attrs = {...this.$attrs, class: ''}
      return attrs
    }
  }
}
</script>

<style lang="scss">
.enext-input--checkbox {
  display: flex;
  align-items: center;

  &.uses-markdown {
    flex-direction: column;
  }

  .checkbox-wrapper {
    display: flex;
    align-items: center;

    .markdown-label {
      max-width: fit-content;
    }

    .k-checkbox {
      & + .k-checkbox-label {
        padding-left: $default-margin-padding-width / 2;
        margin-left: 0;
      }
    }
  }
}
</style>
